// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__2YwRv","button":"Landing_button__1qpZX"};